import ProfilesListReducer from './ProfilesListReducer';

export default from './ProfilesListContainer';
export const ProfilesListReducers = {
  ProfilesListReducer,
};
